/* eslint-disable complexity */
/* eslint-disable class-methods-use-this */
import React from 'react';
import { wrapComponent } from 'utils/framework';
import { Container, Link } from 'components/ui';
import BaseClass from 'components/BaseClass';
import BeautyPreferencesHeader from 'components/BeautyPreferencesRedesigned/Header';
import BeautyPreferencesWorlds from 'components/BeautyPreferencesRedesigned/BeautyPreferencesWorlds/BeautyPreferencesWorlds';
import bpRedesignedUtils from 'utils/BeautyPreferencesRedesigned';
import Location from 'utils/Location';
import localeUtils from 'utils/LanguageLocale';
import userUtils from 'utils/User';
import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import bpRedesignedBindings from 'analytics/bindingMethods/pages/beautyPreferencesRedesigned/beautyPreferencesRedesignedBindings';

const getText = localeUtils.getLocaleResourceFile('components/BeautyPreferencesRedesigned/locales', 'BeautyPreferencesRedesigned');

class BeautyPreferencesRedesigned extends BaseClass {
    state = {
        refinementWorlds: []
    };

    componentDidMount() {
        this.loadRefinements();
        bpRedesignedUtils.executeWhenMasterListLoaded(() => {
            this.loadRefinements();
        });
        bpRedesignedBindings.setPageLoadAnalytics();
    }

    componentDidUpdate() {}

    onWorldClick = e => {
        const href = e?.currentTarget?.getAttribute('href');

        if (href) {
            Location.navigateTo(e, href);
        }
    };

    loadRefinements = () => {
        const refinementWorlds = bpRedesignedUtils.getMasterListRefinementWorldsOrderedById();
        this.setState({
            refinementWorlds
        });
    };

    openPrivacySettings = () => {
        const { openPrivacySettingsModal, customerPreference, user } = this.props;
        const privacySettings = getText('privacySettings');

        const pageName = `${anaConsts.LinkData.COMMUNITY_PROFILE}:${anaConsts.PAGE_NAMES.PROFILE}:${anaConsts.LinkData.BP_PRIVACY_SETTINGS}:*`;
        processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
            data: { pageName }
        });

        this.initialPrivacySetting = user?.socialProfile?.biPrivate;

        openPrivacySettingsModal(privacySettings, customerPreference, user?.socialProfile, this.handlePrivacySettingsSave);
    };

    handlePrivacySettingsSave = profileData => {
        const { closePrivacySettingsModal } = this.props;

        const newPrivacySetting = profileData?.biPrivate;

        if (this.initialPrivacySetting !== newPrivacySetting) {
            const actionInfo = `${anaConsts.LinkData.COMMUNITY_PROFILE.replace(' ', '')}:${anaConsts.PAGE_NAMES.PROFILE}:updated:${anaConsts.LinkData.BP_PRIVACY_SETTINGS}`;

            if (typeof digitalData !== 'undefined' && digitalData.page?.attributes?.previousPageData) {
                digitalData.page.attributes.previousPageData.linkData = actionInfo;
            }

            processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
                data: {
                    actionInfo,
                    linkName: 'D=c55'
                }
            });
        }

        closePrivacySettingsModal(profileData);
    };

    render() {
        const { isAtLeastOneAnswered } = this.props;
        const showPrivacySettings = isAtLeastOneAnswered && userUtils.isSocial();
        const privacySettings = getText('privacySettings');

        return (
            <Container>
                <BeautyPreferencesHeader />
                {this.state.refinementWorlds.length && (
                    <BeautyPreferencesWorlds
                        refinementWorlds={this.state.refinementWorlds}
                        onWorldClick={this.onWorldClick}
                        customerPreference={this.props.customerPreference}
                        recommendations={this.props.recommendations}
                        isAnonymous={this.props.isAnonymous}
                        fetchRecommendations={this.props.fetchRecommendations}
                        biAccount={this.props.biAccount}
                    />
                )}
                {showPrivacySettings && (
                    <Link
                        alignSelf='center'
                        color='blue'
                        onClick={this.openPrivacySettings}
                        display='block'
                        marginTop={6}
                    >
                        {privacySettings}
                    </Link>
                )}
            </Container>
        );
    }
}

export default wrapComponent(BeautyPreferencesRedesigned, 'BeautyPreferencesRedesigned', true);
